import React from "react";
import Layout from "../components/layout/MainLayout";
import HomePage from "../components/routes/Home/Home";
import { graphql } from "gatsby";
import { Container, Row } from "react-bootstrap";
import Blocks from "../components/flexible/FlexibleContent";
import PerformanceHighlights from "../components/routes/PerformanceHighlights/PerformanceHighlignts";
import Archives from "../components/routes/PerformanceHighlights/Archives";
import { SEO } from "wmk-lib";
import Theme from "../vars/ThemeOptions";
import { BackToMain, ImageOffset, Intro } from "../components/common/";

const pageTemplates = {
  home: HomePage,
  "archived-reports": Archives,
};

const Default = ({ page }) => {
  //console.log(page);
  const { title, subText, mainImage, blocks } = page;
  const { json } = subText ? subText : { json: null };
  const { fixed } = mainImage ? mainImage : { fixed: null };
  const _blocks = Array.isArray(blocks) ? blocks : [blocks];
  return (
    <Container fluid style={{ padding: 0 }}>
      <Intro title={title} json={json} backlink="/" />
      {page.slug === "performance-highlights" ? (
        <PerformanceHighlights />
      ) : (
        <ImageOffset
          fixed={fixed}
          alt={mainImage.title}
          nameplate={
            page.slug === "a-note-from-our-ceo"
              ? {
                  header: "Barclay E. Berdan, FACHE",
                  subtitle: "Chief Executive Officer",
                }
              : undefined
          }
        />
      )}
      <Row>
        <Container>
          <Row>
            <Blocks blocks={_blocks} slug={page.slug} />
          </Row>
        </Container>
      </Row>
      <BackToMain />
    </Container>
  );
};

export default ({ pageContext, data }) => {
  const { slug } = pageContext;
  const JSX = pageTemplates[slug];
  const { page } = data;
  const { twitterImage, ogImage } = page;
  return (
    <Layout pageType={"pages"} slug={slug}>
      <SEO.Meta
        title={page.title}
        slug={slug}
        baseUrl={Theme.paths.protocol + "://" + Theme.paths.baseUrl}
        siteTitle={"Texas Health"}
        ogImage={
          ogImage && ogImage.fixed && ogImage.fixed.src
            ? "https:"+ogImage.fixed.src
            : undefined
        }
        twitterImage={
          twitterImage && twitterImage.fixed && twitterImage.fixed.src
            ? "https:"+twitterImage.fixed.src
            : undefined
        }
        twitterHandle={"@texashealth"}
      />
      {JSX ? <JSX page={page} /> : <Default page={page} />}
    </Layout>
  );
};

export const query = graphql`
  query pageQuery($slug: String!) {
    page: contentfulPages(slug: { eq: $slug }) {
      ...NodePagesFields
      ogImage: mainImage {
        fixed(width: 1200, height: 630, quality: 80, cropFocus: FACE) {
          ...GatsbyContentfulFixed_withWebp_noBase64
        }
      }
      twitterImage: mainImage {
        fixed(width: 876, height: 438, quality: 80, cropFocus: FACE) {
          ...GatsbyContentfulFixed_withWebp_noBase64
        }
      }
    }
  }
`;
